const DEVICE_TYPE = {
  IOS: 1,
  ANDROID: 2,
  HUAWEI: 3
};

export { DEVICE_TYPE };
